import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";

export default function EmployeeCard({ element }) {
  const { locale } = useRouter();
  return (
    <div className="w-[calc(50%-20px)] md:w-[calc(33.3%-20px)] lg:w-[calc(25%-20px)] xl:w-[calc(20%-20px)]  py-5 md:border-4 border-white rounded-[15px] flex flex-col items-center px-2 ">
      {/* Employee image */}
      <div className="relative w-[88px] lg:w-[110px] xl:w-[140px] h-[88px] lg:h-[110px] xl:h-[140px] mb-4 shadow-md rounded-full">
        <Image
          src={element?.image}
          alt="Employee Image"
          className="rounded-full"
          objectFit="cover"
          layout="fill"
        />
      </div>

      {/* Employee Name */}
      <h3 className="text-[#010140] text-[18px] lg:text-[20px] xl:text-[22px] font-[590] leading-[26px] text-center mb-[5px] lg:mb-2">
        {element?.name[locale]}
      </h3>

      {/* Employee position */}
      <h4 className="text-[14px] lg:text-[16px] xl:text-[16px] font-[400] leading-[18px] text-center text-[#36A9E1]">
        {element?.postion}
      </h4>
    </div>
  );
}
